import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { CompanyService } from '../../services/company.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-submit-page',
  templateUrl: './submit-page.component.html',
  styleUrls: ['./submit-page.component.scss']
})
export class SubmitPageComponent implements OnInit {
  sub: any;
  orgId: number;

  constructor(
    private titleService: Title,
    private router: Router,
    private route: ActivatedRoute,
    private CompanyService: CompanyService,
    private _location: Location
  ) { }

  ngOnInit() {
    this.titleService.setTitle('Submit Confirmation');
    this.sub = this.route.params.subscribe(params => {
      this.orgId = +params['orgId'];
      this.CompanyService.getCompany(this.orgId)
        .subscribe(org => {
          let steps = JSON.parse(org.steps);
          let incomplete = steps.some(s => {
            return !s[2];
          });
          if (incomplete) {
            this.router.navigate(['/onboarding/dashboard/', this.orgId])
          }
        }, err => {
          console.log(err)
          if (err.status == 401) {
            localStorage.clear();
            this.router.navigate(['/']);
          }
        })
    });
  }

  complete() {
    this.CompanyService.complete(this.orgId)
      .subscribe(company => {
        window.analytics.track("Self-Signup Company Enroled", {OrgId: this.orgId});
        this.router.navigate(['/onboarding/success', this.orgId])
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  cancel() {
    this._location.back();
  }

}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/submit-page/submit-page.component.ts